/**
 * @file store
 * @author YongZhang<zhangyong06@baidu.com>
 */
'use strict';
import Vue from 'vue';
import Vuex from 'vuex';
import {passportOrigin} from '../../config/constant';
Vue.use(Vuex);

export const config = {
    state: {
    },
    mutations: {
    },
    actions: {
        logout(e, authToken) {
            let href
                = location.protocol
                    + '//' + location.host
                    + '/fp/account/index/login'
                    + (authToken ? '?authToken=' + authToken : '');
            // 登出pass
            let passUrl = `${passportOrigin}/?logout`;
            window.location = passUrl + '&tpl=lvlin&u=' + encodeURI(href) +  '&sid=' + window?._pageData?.sid;
        }
    }
};
let storeInstance;

export default {
    getStore() {
        return storeInstance;
    },
    init(modules) {
        config.modules = modules || [];
        storeInstance = new Vuex.Store(config);
        return storeInstance;
    }
};

